<template>
    <div class="head-img2">
        <img v-if="user && user[userImg]" class="img" :src="user && user[userImg]" :class="user.sex == 1 ? 'man-border' : 'woman-border'" />
        <svg v-else class="iconSymbol img" aria-hidden="true">
			<use xlink:href="#iconmorentouxiang" />
		</svg>
        <i v-if="useModal" class="modal"></i>
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            default: () => {}
        },
        userImg: {
            type: String,
            default: 'headimgurl'
        },
        useModal: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" scoped>
.head-img2 {
    position: relative;
}
.img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: rgba($color: #000000, $alpha: 0.2);
    opacity: 0;

    &:hover {
        opacity: 1;
    }
}
</style>